import cn from 'classnames';
import { DSButton } from 'designSystem';
import { motion } from 'framer-motion';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { animationDuration } from './utils';

interface RegistrationManualProps {
	openRegistrationForm: () => void;
	expandMojeId: boolean;
}

export const RegistrationManual: React.FC<RegistrationManualProps> = ({ openRegistrationForm, expandMojeId }) => {
	const { t } = useTranslation();

	return (
		<motion.div
			initial={{ minHeight: 100 }}
			animate={{ maxHeight: expandMojeId ? 104 : 168 }}
			exit={{ maxHeight: 168 }}
			transition={{ duration: animationDuration, ease: 'linear' }}
			className="text-paragraph-sm self-stretch p-4 relative bg-white rounded-16 inline-flex flex-col justify-start items-start"
		>
			<h2
				className={cn('transition-all ease-linear text-gray-900 font-bold my-0 pb-2', expandMojeId ? 'text-h5' : 'text-h3')}
				style={{ transitionDuration: animationDuration + 's' }}
			>
				{t('registrationMethods_manual_header')}
			</h2>
			<motion.div
				initial={{ height: 170 }}
				animate={{ height: expandMojeId ? 0 : 170, opacity: expandMojeId ? 0 : 1 }}
				transition={{ duration: animationDuration, ease: 'linear' }}
			>
				<p className="font-medium text-gray-800 my-0">{t('registrationMethods_manual_subtitle')}</p>
			</motion.div>
			<div className="!absolute bottom-0 left-0 right-0 p-4">
				<DSButton
					size={expandMojeId ? 'small' : 'medium'}
					color="tertiary"
					className={cn('w-full transition-all ease-linear', expandMojeId ? 'mt-2' : 'mt-4')}
					style={{ transitionDuration: animationDuration + 's' }}
					onClick={openRegistrationForm}
					cyTestRef="registration-form"
				>
					{t('registrationMethods_manual_button')}
				</DSButton>
			</div>
		</motion.div>
	);
};
